import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=4f894c20&scoped=true"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentRendererDefault.vue?vue&type=style&index=0&id=4f894c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f894c20",
  null
  
)

export default component.exports